module.exports = __webpack_public_path__ + "static/media/home-1-comp.944cbd38.mp4";